import { render, staticRenderFns } from "./MailExample.vue?vue&type=template&id=475f3fa2&"
import script from "./MailExample.vue?vue&type=script&lang=js&"
export * from "./MailExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports